export const LANG_SIGNIN = {
  signIn: 'Sign In',
  SAPPAcademy: 'SAPP Academy Operations',
  signInGoogle: 'Sign in with Google',
  signInApple: 'Sign in with Apple',
  orWithEmail: 'Or with email',
  email: 'Email',
  password: 'Password',
  forgotPassword: 'Forgot password ?',
  notMember: 'Not a Member yet?',
  signUp: 'Sign up',
  english: 'English',
  japanese: 'Japanese',
  german: 'German',
  spanish: 'Spanish',
  french: 'French',
  terms: 'Terms',
  plans: 'Plans',
  contactUs: 'Contact Us',
  eventTest: 'Event Test',
}

export const MY_COURSES = {
  explanations: 'Explanations',
  hotline: '19002225',
  placeholderSearch: 'Search for your course here',
  placeholderSearch3Level: 'Enter name of course...',
}

export const DESCRIPTION_POPUPCONFIRM = 'Bạn có chắc chắn muốn hủy không?'
export const DELETE_POPUPCONFIRM = 'Bạn có chắc chắn muốn xóa không?'
export const DUPLICATE_POPUPCONFIRM = 'Bạn có chắc chắn muốn sao chép không?'
export const CONFIRM_STATUS_CHANGE =
  'Bạn có chắc chắn muốn đổi trạng thái không?'
export const ACTIVE_POPUPCONFIRM = 'Bạn có muốn kích hoạt chức năng không?'
export const DEACTIVE_POPUPCONFIRM =
  'Bạn có muốn dừng kích hoạt chức năng không?'
export const REFRESH_POPUPCONFIRM = 'Bạn có muốn làm mới chức năng không?'
